import React from 'react';

import classes from './ButtonProceed.scss';

const buttonProceed = (props) => {

    let buttonClass = [classes.ButtonProceed];

    if (props.isactive) {
        buttonClass.push(classes.ButtonProceedActive);
    }

    return (
        <button 
            onClick={props.clicked}
            disabled={!props.isactive}
            className={buttonClass.join(' ')}
            >{props.children}</button>
    )
}

export default buttonProceed;


// WEBPACK FOOTER //
// ./src/components/UI/Button/ButtonProceed/ButtonProceed.js